// JSON.parse without throwing
export function safeParse(input?: string | null) {
  let output;

  try {
    output = JSON.parse(input || "");
  } catch {}

  return output;
}

// Get a value from localStorage.
export const localStorageGet = <A extends any>(k: string): A | null => {
  const item = localStorage.getItem(prefix(k));
  return item !== null ? safeParse(item) : item;
};

// Set a value in localStorage.
export const localStorageSet = <A extends any>(k: string, v: A) => {
  return localStorage.setItem(prefix(k), JSON.stringify(v));
};

// Remove a value from localStorage.
export const localStorageRemove = (k: string) => {
  return localStorage.removeItem(prefix(k));
};

// Get a value from sessionStorage.
export const sessionStorageGet = <A extends any>(k: string): A | null => {
  const item = sessionStorage.getItem(prefix(k));
  return item !== null ? safeParse(item) : item;
};

// Set a value in sessionStorage.
export const sessionStorageSet = <A extends any>(k: string, v: A) => {
  return sessionStorage.setItem(prefix(k), JSON.stringify(v));
};

// Remove a value from sessionStorage.
export const sessionStorageRemove = (k: string) => {
  return sessionStorage.removeItem(prefix(k));
};

export const prefix = (key: string) => `__exabel_${key}`;
export const removePrefix = (key: string) => key.replace("__exabel_", "");
